export default {
  sm: `
  Secure data center around
  the clock
  `,
  md: `
  Secure data center
  around the clock
  `,
  xxl: `
  Secure
  data center
  around the clock
  `
};  